export const normalizePromoVisNavData = ({ slotData, componentData, mediaCollectionIndex = 0 }) => {
  if (slotData?.slot) {
    const { slot } = slotData;
    const mediaCollection = slot.mediaCollections?.[mediaCollectionIndex];
    const mediaItems = mediaCollection?.media || [];

    const getCustomProp = (entry, key) => {
      if (entry?.customProps) {
        try {
          const props = JSON.parse(entry.customProps);
          if (props && typeof props === 'object' && !Array.isArray(props)) {
            return props[key];
          }
          return undefined;
        } catch {
          return undefined;
        }
      }
      return undefined;
    };

    const items = mediaItems.map((media) => {
      const source = media.sourceDesktop?.[0];

      // Extract promotional offer configuration from generic media custom properties
      const showDollar = getCustomProp(media, 'show$');
      const showOff = getCustomProp(media, 'showOff');
      const isSpecialOffer = showDollar || showOff;

      // Create the promotional offer with nested structure matching the component dataModel
      let promotionalOffer = {};

      if (isSpecialOffer) {
        const dollarOffer = {
          eyebrow: media.eyebrow,
          shouldShowDollar: showDollar,
          shouldShowOff: showOff,
          specialOfferHeadline: media.title,
          specialOfferSubhead: media.subtitle,
          cents: getCustomProp(media, 'cents'),
          wasPrice: getCustomProp(media, 'wasPrice'),
          badge: getCustomProp(media, 'badge') // Badge would need to come from a separate media source if available
        };

        promotionalOffer = {
          DollarOrPercentageOffPromotionalOffer: dollarOffer,
          // Flatten for direct access by the card component
          ...dollarOffer
        };
      } else {
        // SimplePromotionalOffer structure
        const simpleOffer = {
          simpleOfferHeadline: media.title,
          simpleOfferSubhead: media.subtitle
        };

        promotionalOffer = {
          SimplePromotionalOffer: simpleOffer,
          // Flatten for direct access by the card component
          ...simpleOffer
        };
      }

      return {
        id: media.entryId,
        link: source?.hyperlink,
        altText: source?.altText || media.title,
        image: {
          url: source?.uri
        },
        previewImage: {
          damDownloadedContent: {
            url: source?.uri
          }
        },
        promotionalOffer,
        theme: media.theme
      };
    });

    const legalCopy = getCustomProp(mediaCollection, 'legalCopy');

    const sectionCTAButton = getCustomProp(mediaCollection, 'sectionCTAButton');

    const overflowBehavior = getCustomProp(mediaCollection, 'overflowBehavior') || 'Wrap';
    const numberOfCardsAcross = getCustomProp(mediaCollection, 'numberOfCardsAcross');

    return {
      source: 'slot',
      items,
      dataComponent: {
        id: mediaCollection?.entryId,
        title: mediaCollection?.title,
        legalCopy,
        sectionCTAButton,
        overflowBehavior,
        numberOfCardsAcross,
        theme: mediaCollection?.theme,
        itemTheme: null,
        promoVisualNavigationList: items,
      }
    };
  }

  if (componentData?.component) {
    const { component } = componentData;
    return {
      source: 'component',
      items: component.promoVisualNavigationList || [],
      dataComponent: component
    };
  }

  return null;
};